"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
const uuid_1 = require("uuid");
const orderItemHelper_1 = require("../orderItemHelper");
/**
 * Adds combo product to an order item.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type AddComboEvent
 * @param prevState previous order
 */
function default_1(event, prevState = {}) {
    var _a, _b;
    let order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const itemStatus = order.status === domain_1.OrderStatus.DRAFT
        ? domain_1.OrderItemStatus.DRAFT
        : domain_1.OrderItemStatus.CREATED;
    const itemToUpdate = order.orderItems.find(item => item.id === event.orderItemId);
    if (!itemToUpdate)
        return order;
    if (!((_a = itemToUpdate.comboItems) === null || _a === void 0 ? void 0 : _a.length))
        itemToUpdate.comboItems = [];
    if ((_b = event.comboItems) === null || _b === void 0 ? void 0 : _b.length) {
        itemToUpdate.comboItems = event.comboItems.map(event => {
            var _a, _b, _c, _d, _e;
            return ({
                id: event.id || (0, uuid_1.v4)(),
                product: {
                    id: event.productId,
                    name: event.productName,
                    ...(((_a = event.optionValues) === null || _a === void 0 ? void 0 : _a.length) && { optionValues: event.optionValues }),
                },
                printerProfiles: event.printerProfiles || [],
                productOriginalPrice: event.productOriginalPrice,
                status: event.fireItem ? itemStatus : domain_1.OrderItemStatus.ON_HOLD,
                modifierGroupId: event.modifierGroupId,
                unitPrice: (_b = event.unitPrice) !== null && _b !== void 0 ? _b : 0,
                quantity: (_c = event.quantity) !== null && _c !== void 0 ? _c : 1,
                course: (event === null || event === void 0 ? void 0 : event.courseId)
                    ? {
                        id: event.courseId,
                        name: event.courseName || '',
                        priority: (_d = event.coursePriority) !== null && _d !== void 0 ? _d : 0,
                    }
                    : null,
                notes: event.note || '',
                seatNumber: event.seatNumber,
                ...(((_e = event.modifiers) === null || _e === void 0 ? void 0 : _e.length) && { modifiers: event.modifiers }),
                ...(event.variantId && {
                    variant: {
                        id: event.variantId,
                        name: event.variantName,
                    },
                }),
            });
        });
        const comboProductPriceMap = event.comboItems.reduce((map, event) => {
            var _a;
            map = {
                ...map,
                [event.productId]: {
                    quantity: event.quantity,
                    productOriginalPrice: event.productOriginalPrice,
                    modifiers: (_a = event.modifiers) !== null && _a !== void 0 ? _a : [],
                },
            };
            return map;
        }, {});
        (0, orderItemHelper_1.updateSavedAndProRatedAmount)(comboProductPriceMap, itemToUpdate);
        (0, orderItemHelper_1.adjustProRateValue)(itemToUpdate);
        itemToUpdate.status = domain_1.OrderItemStatus.CREATED;
    }
    else {
        order.orderItems = order.orderItems.filter(i => i.id !== event.orderItemId);
    }
    order = {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
        lastOrderedAt: event.timestamp,
    };
    if (itemToUpdate.adjustments) {
        itemToUpdate.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(itemToUpdate);
        itemToUpdate.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(itemToUpdate);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=addComboProduct.js.map